import {
  createAwardProjectRichMessage,
  createBanners,
  createBids,
  createContestBudgetRanges,
  createCurrencies,
  createDomain,
  createFreelancerReputations,
  createLanguages,
  createNotificationsPreferences,
  createOnlineOfflines,
  createProjectBudgetOptions,
  createProjectUpgradeFees,
  createProjectViewBids,
  createProjectViewProject,
  createProjectViewUsers,
  createRecentProjectsAndContests,
  createReferralInvitationCheck,
  createSiteStats,
  createSkills,
  createThread,
  createUser,
  createUserBalances,
  createUserCalifornianStatuses,
  createUserGiveGetDetails,
  createUserInfo,
  createUsers,
  createUserSelf,
  updateProjectViewProjectBidStats,
} from '@freelancer/datastore/collections';
import { DatastoreInterface } from '@freelancer/datastore/core';
import { peopleWithSurnames } from '@freelancer/datastore/testing';
import { ContextTypeApi } from 'api-typings/messages/messages_types';
import { ProjectTypeApi } from 'api-typings/projects/projects';

export async function constructInitialStoreState(
  datastore: DatastoreInterface,
  authUid: number,
) {
  // Create self and other me things
  const { id: userId, username } = await createUserSelf(datastore, {
    userId: authUid,
  });
  const user = await createUser(datastore, { userId });
  await createUserInfo(datastore, { userId });
  await createUserGiveGetDetails(datastore, { userId, username });
  await createUserCalifornianStatuses(datastore, { userIds: [userId] });
  await createUserBalances(datastore);
  await createBanners(datastore);
  await createReferralInvitationCheck(datastore, { userId });
  await createNotificationsPreferences(datastore);

  // Create project for PVP
  const project = await createProjectViewProject(datastore, {
    projectId: 42,
    ownerId: userId,
  });
  const { id: projectId } = project;
  await createProjectUpgradeFees(datastore, { projectId });
  const bidders = await createUsers(datastore, { names: peopleWithSurnames });
  await createProjectViewUsers(datastore, { users: [user, ...bidders] });

  const bidderIds = bidders.map(bidder => bidder.id);
  const bids = await createBids(datastore, {
    bidderIds,
    projectId,
    projectOwnerId: userId,
    minAmount: 100,
    maxAmount: 200,
  });
  await createProjectViewBids(datastore, { bids });
  await updateProjectViewProjectBidStats(datastore, { projectId, bids });
  await createFreelancerReputations(datastore, { freelancerIds: bidderIds });
  await createOnlineOfflines(datastore, { userIds: bidderIds });

  // Put project in nav
  await createRecentProjectsAndContests(datastore, { projects: [project] });

  // Create for PJP
  await createProjectBudgetOptions(datastore, {
    projectType: ProjectTypeApi.FIXED,
  });
  await createProjectBudgetOptions(datastore, {
    projectType: ProjectTypeApi.HOURLY,
  });
  await createContestBudgetRanges(datastore);

  // Create global things
  await createSiteStats(datastore, { userId });
  await createLanguages(datastore);
  await createDomain(datastore);
  await createCurrencies(datastore);
  await createSkills(datastore);
  const thread = await createThread(datastore, {
    userId: authUid,
    otherMembers: bidderIds,
    context: { type: ContextTypeApi.PROJECT, id: project.id },
  });
  await createAwardProjectRichMessage(datastore, {
    fromUserId: authUid,
    thread,
    bid: bids[0],
  });
}
